import angular from 'angular';
import ngRoute from 'angular-route';
import ngSanitize from 'angular-sanitize';
import placeholderPolyfill from 'angular-shims-placeholder';
import routeConfig from './main.route';
// Import Modules
import parcelsModule from './angular-services/parcels.module';
import componentsModule from './components.module';
// Import Services (local).
import applicationModel from './services/model.service';
import configService from './services/config.service';
import overlayService from './services/overlay.service';
import routeService from './services/route.service';
import numberService from './services/number.service';
import notificationService from './services/notification.service';
import parcelForceService from './services/parcelForce.service';
import googleRecaptchaService from './components/googlerecaptcha/google-recaptcha.service';
import trackingCodeService from './components/trackingcode/tracking-code.service';
import eventTypeService from './services/eventType.service';

// Import Utils.
import timeFilter from './utils/time.filter';
import statusCategoryFilter from './utils/statusCategory.filter';
import splitNumberFilter from './utils/splitNumber.filter';
import arrayToParagraph from './utils/array.paragraph';
import bootstrap from './utils/bootstrap';
// Import global styles.
import './scss/main.scss';

const MAIN = angular
  .module('app', [ngRoute, parcelsModule, componentsModule, ngSanitize, placeholderPolyfill])
  .config(routeConfig)
  .provider('configService', configService)
  .service('overlayService', overlayService)
  .service('routeService', routeService)
  .service('numberService', numberService)
  .service('notificationService', notificationService)
  .service('parcelForceService', parcelForceService)
  .service('googleRecaptchaService', googleRecaptchaService)
  .service('trackingCodeService', trackingCodeService)
  .service('eventTypeService', eventTypeService)
  .factory('applicationModel', applicationModel)
  .filter('formatTime', timeFilter)
  .filter('arrayToParagraph', arrayToParagraph)
  .filter('statusCategoryFilter', statusCategoryFilter)
  .filter('splitNumberFilter', splitNumberFilter)
  .name;

export default MAIN;

bootstrap();



// WEBPACK FOOTER //
// ./src/main.module.js